"use client";

import React from "react";
import { Zap, BarChart3, ShieldCheck, Blocks } from "lucide-react";
const features = [{
  title: "Propulsão de Alta Performance",
  description: "Motores brushless otimizados para voos de até 45 minutos com estabilidade máxima em ventos de 40km/h.",
  icon: Zap,
  specs: "45min Flight Time"
}, {
  title: "Sensores de Precisão 8K",
  description: "Captura de dados multiespectrais com sensores de última geração para mapeamento topográfico detalhado.",
  icon: BarChart3,
  specs: "8K Sensor Res"
}, {
  title: "Sistemas de Redundância",
  description: "Protocolos de segurança triplos e GPS diferencial para garantir a integridade da missão em qualquer cenário.",
  icon: ShieldCheck,
  specs: "Triple Redundancy"
}, {
  title: "Arquitetura Modular",
  description: "Troca rápida de payloads e integração via SDK para customização total das suas operações aéreas.",
  icon: Blocks,
  specs: "SDK Integration"
}];
export default function BeneficiosEFuncionalidades() {
  return <section data-section-id="227857" id="tecnologia" className="bg-background text-foreground relative overflow-hidden py-[160px]">
      {}
      <div className="absolute inset-0 bg-background" />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="mb-16 text-center">
          <h2 className="font-default text-3xl md:text-5xl font-bold text-foreground mb-6">
            Excelência Técnica
          </h2>
          <p className="font-default text-lg text-muted-foreground max-w-2xl mx-auto">
            Engenharia de ponta e componentes de classe industrial projetados para 
            superar os desafios mais complexos da aviação não tripulada.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-6">
          {features.map((feature, i) => <div key={i} data-index={i} className="col-span-12 md:col-span-6 lg:col-span-3 group relative flex flex-col bg-card border border-border rounded-[20px] p-8 transition-all duration-[400ms] ease-[cubic-bezier(0.25,1,0.5,1)] hover:scale-[1.02] hover:border-primary/50 hover:shadow-[0_0_20px_rgba(159,255,0,0.15)]">
              <div className="mb-8 inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-secondary border border-border transition-colors duration-[400ms] group-hover:bg-accent group-hover:border-primary/30">
                <feature.icon className="size-8 text-muted-foreground transition-colors duration-300 group-hover:text-primary" />
              </div>
              
              <h3 className="font-default text-[24px] font-bold text-foreground mb-4 leading-tight">
                {feature.title}
              </h3>
              
              <p className="font-default text-[18px] text-muted-foreground leading-relaxed mb-6">
                {feature.description}
              </p>

              <div className="mt-auto pt-4 border-t border-border/50">
                <span className="font-mono text-xs uppercase tracking-wider text-primary/80">
                  {feature.specs}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}